var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6132 0.770802C21.3996 -0.256934 23.6004 -0.256934 25.3868 0.770802L42.1132 10.3941C43.8996 11.4219 45 13.3212 45 15.3767V34.6233C45 36.6788 43.8996 38.5781 42.1133 39.6059L25.3868 49.2292C23.6004 50.2569 21.3996 50.2569 19.6132 49.2292L2.88675 39.6059C1.10042 38.5781 0 36.6788 0 34.6233V15.3767C0 13.3212 1.10042 11.4219 2.88675 10.3941L19.6132 0.770802ZM7.77757 34.4159C7.24167 34.1076 6.91154 33.5378 6.91154 32.9212V17.0788C6.91154 16.4622 7.24167 15.8924 7.77757 15.5841L21.5455 7.66289C22.0814 7.35457 22.7417 7.35457 23.2776 7.66289L37.0455 15.5841C37.5814 15.8924 37.9115 16.4622 37.9115 17.0788V22.5322C37.9115 23.1664 37.5625 23.7495 37.0026 24.0509L24.9988 30.5115C23.8374 31.1366 22.4293 30.2892 22.4437 28.974L22.4888 24.8721C22.4957 24.2414 22.8472 23.6648 23.4056 23.368L28.2802 20.7773C29.5057 20.126 29.502 18.3743 28.2737 17.7281L23.2576 15.0891C22.7311 14.8121 22.0986 14.824 21.583 15.1207L14.1284 19.4095C13.5925 19.7179 13.2624 20.2877 13.2624 20.9043V29.0957C13.2624 29.7123 13.5925 30.2821 14.1284 30.5904L21.5455 34.8578C22.0814 35.1661 22.7417 35.1661 23.2776 34.8578L35.3135 27.9331C36.4682 27.2688 37.9116 28.0992 37.9116 29.4279V32.9212C37.9116 33.5378 37.5814 34.1076 37.0455 34.4159L23.2776 42.3371C22.7417 42.6454 22.0814 42.6454 21.5455 42.3371L7.77757 34.4159Z",
    fill: "#8C8C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.82f9c3914dc5428faa71f0f7eb156e4e.svg";
export { ForwardRef as ReactComponent };